<template>
  <div style="height: 100%; display: flex; align-items: center; justify-content: center; padding: 1.5rem; background-color: #ddd;">
    <v-card class="elevation-6" style="width: 100%; max-width: 480px;">
      <v-card-title style="color: white; background-color: #005f7b; font-weight: bold;">Aanmelden</v-card-title>
      <div style="padding: 1.5rem;">
        <p v-if="msg != ''" style="color: red;">{{ msg }}</p>
        <v-text-field v-model="logindata.username" label="Gebruikersnaam" required
                      ref="gebnaam" @keyup.enter="focusPasswd"></v-text-field>
        <v-text-field v-model="logindata.password" label="Wachtwoord" password required
                      ref="passwd" @keyup.enter="aanmeldenClick"
                      :append-icon="toonpwd ? 'visibility_off' : 'visibility'"
                      :type="toonpwd ? 'text' : 'password'"
                      @click:append="toonpwd = !toonpwd" ></v-text-field>
        <v-checkbox v-model="blijf_aangemeld" label="Blijf aangemeld op dit apparaat"></v-checkbox>
        <div style="text-align: center;">
          <v-btn color="success" @click="aanmeldenClick" style="margin: 1rem auto 0 auto;" default>Aanmelden</v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  export default {
    data: () => ({
      logindata: {'username': "", 'password': ""},
      blijf_aangemeld: false,
      toonpwd : false,
      msg: ""
    }),
    computed: mapState(['api']),
    methods: {
      ...mapMutations(['setAuthToken']),
      focusPasswd: function() {
        this.$refs.passwd.focus()
      },
      aanmeldenClick: async function() {
        let r = await this.api.post('aanmelden', this.logindata)
        this.msg = r.data.msg || ""
        if (r.data.success) {
          if (this.blijf_aangemeld) {
            localStorage.setItem('authToken', r.data.token)
            this.setAuthToken("")
          } else {
            localStorage.removeItem('authToken')
            this.setAuthToken(r.data.token)
          }
          this.$router.push('/')
        }
      }
    },
    mounted () {
      this.$refs.gebnaam.focus()
    }
  }
</script>

<style>

</style>
